{
  "name": "taas-km-frontend-angular",
  "version": "0.11.17",
  "scripts": {
    "ng": "ng",
    "lint": "ng lint",
    "test": "vitest --no-watch",
    "test:watch": "vitest --watch",
    "test:ui": "vitest --ui",
    "test:coverage": "vitest run --coverage",
    "test:ci": "vitest run",
    "start": "ng serve",
    "start-dev": "ng serve --configuration development",
    "start-prod": "ng serve --configuration production",
    "start-preprod": "ng serve --configuration preprod",
    "start-poc": "ng serve --configuration poc",
    "start-de": "ng serve --configuration=de",
    "start-en": "ng serve --configuration=en",
    "start-se": "ng serve --configuration=se",
    "translate": "ng extract-i18n",
    "build": "ng build",
    "build:stats": "ng build --stats-json && esbuild-visualizer --metadata ./dist/taas-km-frontend-angular/stats.json --filename ./dist/taas-km-frontend-angular/stats.html && open-cli ./dist/taas-km-frontend-angular/stats.html",
    "build-prod": "ng build --configuration production",
    "build-preprod": "ng build --configuration preprod",
    "build-poc": "ng build --configuration poc",
    "build-dev": "ng build --configuration development",
    "watch": "ng build --watch --configuration development"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.1",
    "@angular/cdk": "^21.2.1",
    "@angular/common": "^21.2.1",
    "@angular/compiler": "^21.2.1",
    "@angular/core": "^21.2.1",
    "@angular/forms": "^21.2.1",
    "@angular/material": "^21.2.1",
    "@angular/platform-browser": "^21.2.1",
    "@angular/platform-browser-dynamic": "^21.2.1",
    "@angular/router": "^21.2.1",
    "@material-icons/svg": "1.0.33",
    "@popperjs/core": "^2.11.8",
    "chart.js": "^4.4.1",
    "jquery": "^3.7.1",
    "jwt-decode": "^4.0.0",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^24.0.3",
    "ng2-charts": "^5.0.4",
    "rxjs": "~7.8.0",
    "taas-km-frontend-angular": "file:",
    "tslib": "^2.3.0",
    "utimaco-common-ui-angular": "https://repo.fra1.us.utimaco.cloud/repository/npm-hosted/utimaco-common-ui-angular/-/utimaco-common-ui-angular-1.27.4.tgz",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.3.1",
    "@angular-eslint/builder": "^21.3.0",
    "@angular-eslint/eslint-plugin": "^21.3.0",
    "@angular-eslint/eslint-plugin-template": "^21.3.0",
    "@angular-eslint/schematics": "^21.3.0",
    "@angular-eslint/template-parser": "^21.3.0",
    "@angular/cli": "^21.2.1",
    "@angular/compiler-cli": "^21.2.1",
    "@angular/localize": "^21.2.1",
    "@typescript-eslint/eslint-plugin": "^8.56.1",
    "@typescript-eslint/parser": "^8.56.1",
    "@vitest/coverage-v8": "^4.1.0",
    "@vitest/ui": "^4.1.0",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.39.3",
    "jsdom": "^29.0.1",
    "ng-extract-i18n-merge": "^3.3.0",
    "open-cli": "^9.0.0",
    "typescript": "~5.9.3",
    "vitest": "^4.1.0"
  }
}
